import axiosClient from '../../configs/axios';


class AccountManagerMasterService {
    // Get list 
    async getAccountManagerList(params) {
        try {
            const response = await axiosClient.get(
                `/account-manager/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addAccountManager(data) {
        try {
            const response = await axiosClient.post('/account-manager/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteAccountManager(data) {
        try {
            const response = await axiosClient.put(`/account-manager/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new AccountManagerMasterService(); 